import { ApiError, BASE, getCsrfToken } from "./constants";

export async function unsubscribe(hash: string): Promise<void> {
  const response = await fetch(
    `${BASE}/events/subscription/${encodeURIComponent(hash)}`,
    {
      method: "DELETE",
      headers: { "X-CSRFToken": getCsrfToken() },
    },
  );
  if (!response.ok) throw new ApiError(response.status, null);
}

export async function onboardingUnsubscribe(hash: string): Promise<void> {
  const response = await fetch(
    `${BASE}/onboarding/subscription/${encodeURIComponent(hash)}`,
    {
      method: "DELETE",
      headers: { "X-CSRFToken": getCsrfToken() },
    },
  );
  if (!response.ok) throw new ApiError(response.status, null);
}
